import { loop, Effects } from 'redux-loop';
import { routeReducer, routeActions } from 'react-router-redux';
import { UPDATE_QUERY, RESET_QUERY, SET_DEFAULT_MEDIATYPE, PUSH_PATH_NAME } from './actions';

import { setDefaultMediaType } from './tasks';


export default (state = {}, action) => {
  const nextState = routeReducer(state, action);

  if (action.type === UPDATE_QUERY) {
    return loop(
      nextState
    ,
      Effects.batch([
        Effects.call(setDefaultMediaType, action.query),
        Effects.constant(routeActions.push({
          pathname: nextState.location.pathname,
          query: {
            ...nextState.location.query,
            ...action.query,
          },
        }))
      ])

    );
  }

  if (action.type === RESET_QUERY) {
    return loop(
      nextState
    ,
      Effects.batch([
        Effects.call(setDefaultMediaType, action.query),
        Effects.constant(routeActions.push({
          pathname: nextState.location.pathname,
          query: {
            ...action.query,
          },
        }))
      ])

    );
  }

  if (action.type === SET_DEFAULT_MEDIATYPE) {
    return loop(
      nextState
    ,
      Effects.call(setDefaultMediaType, action.data),
    )
  }

  return loop(nextState, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/router/reducer.js
 **/